export type LocalizedLabel = string | Record<string, string>

export function pickLabel(
  label: LocalizedLabel | undefined | null,
  locale: string,
  fallback = 'en'
): string {
  if (label == null) return ''
  if (typeof label === 'string') return label
  return label[locale] ?? label[fallback] ?? Object.values(label)[0] ?? ''
}
